// src/utils/api.js
import { getToken } from './tokenProvider';

const origin = window.location.origin;
export const API_BASE = `${origin}/api`;

// Strip the `/api` suffix so we can hit static assets like /uploads/sounds/...
export const API_ORIGIN = API_BASE.replace(/\/api\/?$/, '');

/**
 * Wrapper for fetch() with JWT token support.
 */
export async function apiFetch(endpoint, options = {}) {
  const token = await getToken();

  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  // Only set JSON Content-Type if we're NOT sending FormData
  if (!(options.body instanceof FormData) && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  const res = await fetch(`${API_BASE}${endpoint}`, {
    ...options,
    headers,
  });

  if (res.status === 401) {
    console.warn('🔒 Unauthorized — token missing/expired');
  }

  return res;
}
